<template>
  <DxDropDownButton
    :items="items"
    :drop-down-options="{ width: 141.41, maxHeight: 179 }"
    :scrollable="true"
    :text="$t('common.grid.selectActions')"
    class="selectActions"
    itemTemplate="actionsTemp"
  >
    <template #actionsTemp="{ data }">
      <div
        class="dropdown-wrapper"
        :class="{
          'hide-journey-border':
            data.text ==
            items.filter((item) => item.visible)[
              items.filter((item) => item.visible).length - 1
            ].text,
        }"
        title=""
        @click="
          data.id == 'delete'
            ? deleteModal(
                journeyData.id,
                journeyData.mod_Parent_ID == 0 ? 'journey' : 'flow'
              )
            : redirectTo(data.id)
        "
      >
        <div
          class="dropdown-items"
          :class="{ 'red-remove': data.id == 'delete' }"
          title=""
        >
          {{ data.text }}
        </div>
      </div>
    </template>
  </DxDropDownButton>
</template>

<script>
import { mapActions } from "vuex";
import DxDropDownButton from "devextreme-vue/drop-down-button";

export default {
  name: "JourneyActions",
  props: ["journeyData"],
  components: {
    DxDropDownButton,
  },
  data() {
    return {
      items: [
        {
          text: this.$t("journeyBuilder.grid.editJourney"),
          id: "editJourney",
          visible: this.journeyData.mod_Parent_ID == 0,
        },
        {
          text: this.$t("journeyBuilder.grid.deleteJourney"),
          id: "delete",
          visible:
            this.journeyData.mod_Parent_ID == 0 && this.journeyData.canDelete,
        },
        {
          text: this.$t("journeyBuilder.grid.addFlow"),
          id: "addFlow",
          visible:
            this.journeyData.mod_Parent_ID == 0 && this.journeyData.canAddFlow,
        },
        {
          text: this.$t("journeyBuilder.grid.editFlow"),
          id: "editFlow",
          visible: this.journeyData.mod_Parent_ID != 0,
        },
        {
          text: this.$t("journeyBuilder.grid.deleteFlow"),
          id: "delete",
          visible:
            this.journeyData.mod_Parent_ID != 0 &&
            this.journeyData.canDeleteFlow,
        },
      ],
    };
  },
  methods: {
    ...mapActions("journey", ["deleteJourney"]),
    ...mapActions("journeyFlow", ["deletejourneyFlow"]),
    redirectTo(type) {
      switch (type) {
        case "addFlow":
          return this.$router.push(`/add/journey/flow/${this.journeyData.id}`);
        case "editFlow":
          return this.$router.push(
            `/update/journey/flow/${this.journeyData.id}`
          );
        case "editJourney":
          return this.$router.push(`/update/journey/${this.journeyData.id}`);
        default:
          null;
      }
    },
    deleteModal(id, type) {
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to delete ${
            type == `journey` ? `journey` : `journey flow`
          } ?`,
          {
            title: "Confirmation",
            size: "md",
            buttonSize: "md",
            okVariant: "primary",
            okTitle: "Confirm",
            cancelVariant: "outline-secondary",
            headerClass: "p-2 border-bottom-0 h1",
            footerClass: "p-2 border-top-0",
            centered: true,
          }
        )
        .then((proceed) => {
          if (proceed) {
            switch (type) {
              case "journey":
                this.deleteJourney(id).then(() => {
                  this.$emit("fetchJourneys");
                });

                break;
              case "flow":
                this.deletejourneyFlow(id).then(() => {
                  this.$emit("fetchJourneys");
                });
                break;
              default:
                "";
                break;
            }
          }
        });
    },
  },
};
</script>

<style lang="scss">
.hide-journey-border {
  border: none !important;
}

.dropdown-wrapper {
  padding: 0;
  border-bottom: 1px solid #e9e9e9;
  .dropdown-items {
    font-weight: 400;
    font-size: 16px !important;
    text-align: center;
    line-height: 19px !important;
    color: #787878;
    margin: 6px auto 12px auto !important;
    white-space: break-spaces;
  }
  .red-remove {
    color: #f46a6a !important;
  }
}

.dx-scrollable-scroll.dx-state-invisible,
.dx-scrollable-scroll-content {
  background: #666666 !important;
  border-radius: 8.5px !important;
}

.dx-scrollable-scrollbar.dx-widget.dx-scrollbar-vertical.dx-scrollbar-hoverable {
  background: #ededed !important;
  border-radius: 8.5px !important;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
}
</style>
